import type { ISaveReviewRequest } from '../saveReview/save-review-request';
import { saveReviewRequestSchema } from '../saveReview/save-review-request';

export const saveReviewV2RequestSchema = saveReviewRequestSchema;
export type ISaveReviewV2Request = ISaveReviewRequest;
